export const colors = {
  generosityBackgroundDefault: "#5F4F00",
  generosityBackgroundSubtle: "#2E2600",
  generosityBackgroundStrong: "#8A7000",
  generosityBackgroundStaticDefault: "#FFDC2E",
  generosityBackgroundStaticSubtle: "#FFF6BD",
  generosityBackgroundStaticStrong: "#EAC300",
  generosityBackgroundCasinoDefault: "#7401B7",
  generosityBackgroundCasinoSubtle: "#36005B",
  generosityBackgroundCasinoStrong: "#61019B",
  generosityBackgroundCasinoStatic: "#C18FFE",
  generosityBackgroundRacingDefault: "#005D23",
  generosityBackgroundRacingSubtle: "#002E11",
  generosityBackgroundRacingStrong: "#00491C",
  generosityBackgroundRacingStatic: "#7FD9A1",
  generosityBorderDefault: "#8A7000",
  generosityBorderSubtle: "#5F4F00",
  generosityBorderStaticDefault: "#EAC300",
  generosityBorderStaticSubtle: "#FFDC2E",
  generosityBorderCasinoDefault: "#7401B7",
  generosityBorderCasinoSubtle: "#8F02E1",
  generosityBorderCasinoStatic: "#C18FFE",
  generosityBorderRacingDefault: "#005D23",
  generosityBorderRacingSubtle: "#00732C",
  generosityBorderRacingStatic: "#7FD9A1",
  generosityGradientDefault: "linear-gradient(45deg, #5F4F00 50%, #2E2600 88%)",
  generosityGradientStart: "#5F4F00",
  generosityGradientEnd: "#2E2600",
  generosityGradientCasinoDefault: "linear-gradient(45deg, #7401B7 50%, #36005B 88%)",
  generosityGradientCasinoStart: "#7401B7",
  generosityGradientCasinoEnd: "#36005B",
  generosityGradientRacingDefault: "linear-gradient(45deg, #005D23 50%, #002E11 88%)",
  generosityGradientRacingStart: "#005D23",
  generosityGradientRacingEnd: "#002E11",
};